// MoodCheckIn.js - Mood-Based Task Recommendations
import React, { useState } from 'react';

const MoodCheckIn = () => {
    const [mood, setMood] = useState('Neutral');
    const moods = ['Great 😊', 'Neutral 😐', 'Tired 😴'];

    return (
        <div className="p-4 bg-gray-50 rounded shadow-sm my-2 mx-4">
            <h2 className="font-semibold text-indigo-700">How's your energy right now?</h2>
            <div className="flex space-x-2 mt-2">
                {moods.map(m => (
                    <button
                        key={m}
                        className={`px-3 py-1 rounded-full ${mood === m ? 'bg-indigo-500 text-white' : 'bg-white border'}`}
                        onClick={() => setMood(m)}
                    >
                        {m}
                    </button>
                ))}
            </div>
            <p className="mt-2 text-sm text-gray-600">Recommended tasks adjusted based on your energy: {mood}</p>
        </div>
    );
};

export default MoodCheckIn;